// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { QualityRepoService } from '@client/app/services/api/quality-repo/quality-repo.service';
import { CrawlsRepoService } from '@client/app/services/api/crawls-repo/crawls-repo.service';
import { SpellingRepoService } from '@client/app/services/api/spelling-repo/spelling-repo.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { ReadabilityRepoService } from '@client/app/services/api/readability-repo/readability-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Component({
    selector: 'quality-summary',
    standalone: false,
    template: `
        <page-header [icon]="['QA', 'SUMMARY'] | monIcons"
                     [header]="'Content Quality Summary' | translate"
                     [subHeader]="'Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)'
                                   | translate">
                <page-header-content>
                    <div class="row">
                        <div class="col-48 text-right">
                            <csv-export-button clsSize="py-2 px-3"
                                               clsMargin="mr-0"
                                               [exports]="exports">
                            </csv-export-button>
                        </div>
                    </div>
                </page-header-content>
        </page-header>

        <div class="row">
            <div class="col-48 col-md-24">
                <violation-modules [qaSummary]="qaSummary"
                                   [progress]="progress">
                </violation-modules>
                <important-highlights [spellingErrors]="spellingErrors"
                                      [brokenLink]="brokenLink"
                                      [brokenImage]="brokenImage"
                                      [progress]="progress"
                                      [data]="qaSummary">
                </important-highlights>
                <qa-summary-readability [progress]="progress"
                                        *ngIf="hasReadability"
                                        [loading]="loading"
                                        [readabilitySummary]="readabilitySummary">
                </qa-summary-readability>
            </div>
            <div class="col-48 col-md-24">
                <last-scan [progress]="progress"
                           [history]="history"
                           [qaSummary]="qaSummary">
                </last-scan>
            </div>
        </div>
    `,
})
export class QualitySummaryComponent implements OnInit {
    domainId: any;
    hasReadability: any;
    readabilitySummary: any = {};
    qaSummary: any = {};
    history: any[] = [];
    spellingErrors: any[] = [];
    brokenLink: any = {};
    brokenImage: any = {};
    loading = true;
    exports: any[] = [];
    progress: any;

    constructor (
        private stateService: StateService,
        private qualityRepoService: QualityRepoService,
        private crawlsRepoService: CrawlsRepoService,
        private spellingRepoService: SpellingRepoService,
        private linksRepoService: LinksRepoService,
        private readabilityRepoService: ReadabilityRepoService,
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domainId = this.stateService.params.domainId;
        this.hasReadability = this.activeFeatureService.isFeatureActivePure('admin_readability');
        this.readabilitySummary = {};
        this.qaSummary = {};
        this.history = [];
        this.spellingErrors = [];
        this.brokenLink = {};
        this.brokenImage = {};
        this.loading = true;

        const promises: any[] = [
            this.getQASummary(),
            this.getCrawls(),
            this.getSpellingErrors(),
            this.getLinks('not_image', 'dead'),
            this.getLinks('image', 'dead'),
        ];

        if (this.hasReadability) {
            promises.push(this.getReadabilitySummary());
        }

        this.exports = [
            {
                name: this.translateService.getString('Content Quality Summary'),
                data: {
                    category: 'qa_summary',
                },
            },
        ];

        this.progress = Promise.all(promises).then((values: any) => {
            this.qaSummary = values[0];
            this.history = values[1].reverse();
            this.spellingErrors = values[2];
            this.brokenLink = values[3].length > 0 ? values[3][0] : null;
            this.brokenImage = values[4].length > 0 ? values[4][0] : null;

            if (this.hasReadability) {
                this.readabilitySummary = values[5];
            }
            this.loading = false;
        }, () => {});
    }

    getQASummary () {
        const params = {
            domainId: this.domainId,
        };
        return this.qualityRepoService.getSummary(params);
    }

    getReadabilitySummary () {
        return this.readabilityRepoService.summary();
    }

    getCrawls () {
        const params = {
            page: 1,
            page_size: 5,
        };
        return this.crawlsRepoService.getAll(params);
    }

    getSpellingErrors () {
        const params = {
            domainId: this.domainId,
            page: 1,
            page_size: 1,
            sort_by: 'html_pages_count',
            classification: 'confirmed',
            page_fixed: false,
        };
        return this.spellingRepoService.getAllErrors(params);
    }

    getLinks (type: any, status: any, sortBy?: any) {
        const params = {
            page: 1,
            page_size: 1,
            status: status,
            type: type,
            sort_by: sortBy || 'dead_on_pages_count',
            sort_dir: 'desc',
            page_fixed: false,
        };
        return this.linksRepoService.getAll(params);
    }
}
